const enums = {
// 角色
    accountType: {
        1: "模拟账户",
        2: "真实账户",
        3: "比赛账户"
    }
}

const baseHost = process.env.VUE_APP_BASE_API;

export {
    enums,
    baseHost
}

